import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.login');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-login',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.login/view.scss */
:host {
  display: block;
  height: 100%;
}`],
})
export class PageLoginComponent implements OnInit {
    public isLoading: boolean = false;
    public ready: boolean = false;
    public showAdminLogin: boolean = false;
    public adminEmail: string = '';
    public adminPassword: string = '';
    public adminError: string = '';

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();

        let res = await wiz.call("check_auth");
        if (res.data?.authenticated) {
            this.service.href('/home');
            return;
        }

        this.ready = true;
        await this.service.render();
    }

    public async socialLogin(provider: string) {
        this.isLoading = true;
        await this.service.render();

        try {
            let res = await wiz.call("social_login", { provider });

            if (res.code === 200 && res.data?.redirect_url) {
                window.location.href = res.data.redirect_url;
                return;
            }

            if (res.code === 200 && res.data?.demo) {
                let demo = await wiz.call("demo_login", { provider });
                if (demo.code === 200) {
                    this.service.href('/home');
                    return;
                }
            }
        } catch (e) {
        }

        this.isLoading = false;
        await this.service.render();
    }

    public async toggleAdminLogin() {
        this.showAdminLogin = !this.showAdminLogin;
        this.adminError = '';
        await this.service.render();
    }

    public async adminLogin() {
        if (!this.adminEmail || !this.adminPassword) {
            this.adminError = '아이디와 비밀번호를 입력해주세요.';
            await this.service.render();
            return;
        }

        this.isLoading = true;
        this.adminError = '';
        await this.service.render();

        let res = await wiz.call("admin_login", {
            email: this.adminEmail,
            password: this.adminPassword
        });

        this.isLoading = false;

        if (res.code === 200) {
            this.service.href('/home');
            return;
        }

        this.adminError = res.data?.message || '로그인에 실패했습니다.';
        await this.service.render();
    }
}

export default PageLoginComponent;